import { render, staticRenderFns } from "./PermissionsUser.vue?vue&type=template&id=24da5d68&"
import script from "./PermissionsUser.vue?vue&type=script&lang=js&"
export * from "./PermissionsUser.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports